module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("akQ08"))).then(() => parcelRequire('37nVf'));